module.exports = __webpack_public_path__ + "img/Happiness@3x.0ea2a43d.png";